import React from "react";
import { NavLink } from "react-router-dom";
import PT from "prop-types";
import cn from "classnames";
import ReactGA from 'Shared/analytics';


const NavbarItemLink = (props) => {
	let {
		active,
		point: { text, icon, path, isMobileProject },
		isMobileProjectItem
	} = props;

	/*According to the requirements, when you click on the mobile builds Icon,
	the last project should open 
	When menu is minimized, the Icom should be active */
	if (isMobileProjectItem && !JSON.parse(window.localStorage.getItem('isNavbarOpen'))) {
		active = true;
	}

	const closeMenu = () => {
		if (window.innerWidth < 767) {
			document.body.classList.add("toggle-menu");
		}
	};

	const handleExternalLinks = () => {
		if(path.includes('https')){
			ReactGA.outboundLink({
				label: 'External link'
			  })
		}
	}

	return (
		<li className={cn("navbar__item", { _active: active })}>
			{path && path.startsWith("http") ? (
				<a href={path} className={"navbar__item-link"} onClick={closeMenu}>
					{icon}
					<span className="navbar__item-text">{text}</span>
				</a>
			) : (
					<NavLink
						className={cn("navbar__item-link")}
						activeClassName="active-project__link navbar__active"
						exact
						to={path ? path : "/"}
						onClick={(event) => { closeMenu(event); handleExternalLinks(event)}}
					>
						{icon}
						<span
							className={cn("navbar__item-text", {
								"mobile--project": isMobileProject,
							})}
						>
							{text}
						</span>
					</NavLink>
				)}
		</li>
	);
};

NavbarItemLink.propTypes = {
	point: PT.object,
	active: PT.bool,
	onClick: PT.func,
};

export default NavbarItemLink;
